/** @jsxImportSource @emotion/react */

import AddRoundedIcon from '@mui/icons-material/AddRounded'
import Typography from '@mui/material/Typography'
import React, { FC, SyntheticEvent } from 'react'
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg'
import { searchTeamMember_searchTeamMember_items as SearchedTeamMember } from '../../../__generatedTypes__/searchTeamMember'
import * as classes from './styles'

interface IProps {
  member: SearchedTeamMember
  onAddClick: (member: SearchedTeamMember) => void
  onEditClick: (member: SearchedTeamMember) => void
}

const TeamMemberRenderItem: FC<IProps> = ({ member, onAddClick, onEditClick }) => {
  const handleItemAdd = async (e: SyntheticEvent<SVGSVGElement | HTMLDivElement>) => {
    e.stopPropagation()
    onAddClick(member)
  }

  const handleItemEdit = (e: SyntheticEvent<SVGSVGElement>) => {
    e.stopPropagation()
    onEditClick(member)
  }

  return (
    <div css={classes.renderItem} onClick={handleItemAdd}>
      <div css={classes.block}>
        <div css={classes.avatar}>
          <img css={classes.avatar} src={member.getAvatar.photo || ''} alt="Team member avatar" />
        </div>
        <Typography variant="body2" css={classes.longText}>
          {member.fullName}
        </Typography>
      </div>
      <div css={classes.block}>
        <EditIcon css={classes.editIcon} onClick={handleItemEdit} />
        <AddRoundedIcon css={[classes.editIcon, classes.iconPlus]} onClick={handleItemAdd} />
      </div>
    </div>
  )
}

export default TeamMemberRenderItem
